import Cleave from 'cleave.js'

class InputFormat {

	el = null
	binding = null

	created(el, binding) {
		if (!Object.keys(binding.value || {}).length) return
        el.cleave = new Cleave(el, binding.value || {})
    }

	mounted(el, binding) {
		console.log('mounted', el.cleave)
		if (el.cleave || !Object.keys(binding.value || {}).length) return
		el.cleave = new Cleave(el, binding.value || {})
	}

    updated(el) {
		if (!el.cleave) return
        const event = new Event('input', {bubbles: true})
        setTimeout(function () {
		console.log('setRaw',  el.cleave.getRawValue())
			el.setAttribute('data-raw', el.cleave.getRawValue())
			console.log('el', el.value)
            el.value = el.cleave.properties.result
            el.dispatchEvent(event)
        }, 100);
    }
}

export const installInputFormat = (app) => {
	const instance = new InputFormat()

	app.directive('formatter', {
		created: instance.created.bind(instance),
		updated: instance.updated.bind(instance),
		mounted: instance.mounted.bind(instance),
	})
}
